// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__38eO9","footer":"ModalError_footer__2GrWV"};